// The lost reason's decisions, shared by the board's drop dialog
// (deals_board_controller.js) and the move forms (lost_reason_controller.js);
// pure, so `yarn test` checks them without a browser. A move into a lost
// stage needs a reason, and a note when the reason asks for one
// (Crm::Deals::Loss on the server says the same).

// Whether a <select>'s chosen option is a lost stage (data-lost="true").
export function isLostOption(option) {
  return Boolean(option && option.dataset && option.dataset.lost === "true")
}

// Whether a chosen reason option asks for a note (data-note-required="true").
export function noteRequired(option) {
  return Boolean(option && option.dataset && option.dataset.noteRequired === "true")
}

// The message to show for a reason and note, or null when they are enough.
export function reasonError(reasonId, note, needsNote) {
  if (!String(reasonId || "").trim()) return "Vyber dôvod straty."
  if (needsNote && !String(note || "").trim()) return "Tento dôvod potrebuje poznámku."
  return null
}

// The JSON body of a board move: the stage, the reason when there is one, the board's filters.
export function moveBody(stageId, reason, filters) {
  const body = { stage_id: stageId }
  if (reason && reason.lost_reason_id) {
    body.lost_reason_id = reason.lost_reason_id
    if (reason.lost_note) body.lost_note = reason.lost_note
  }
  return { ...body, ...(filters || {}) }
}
